/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ValiantImport } from './routes/valiant'
import { Route as IndexImport } from './routes/index'
import { Route as AuthSuccessImport } from './routes/auth/success'
import { Route as AuthOauthImport } from './routes/auth/oauth'
import { Route as AuthFailureImport } from './routes/auth/failure'
import { Route as LangCompanyIdIndexImport } from './routes/$lang.$companyId/index'
import { Route as SsoCallbackProviderImport } from './routes/sso.callback.$provider'
import { Route as LangCompanyIdContactIdIndexImport } from './routes/$lang.$companyId/$contactId/index'
import { Route as LangCompanyIdPublicSalesCallSessionImport } from './routes/$lang.$companyId/public/sales-call-session'
import { Route as LangCompanyIdPublicContactImport } from './routes/$lang.$companyId/public/contact'
import { Route as LangCompanyIdAdminUsersImport } from './routes/$lang.$companyId/admin/users'
import { Route as LangCompanyIdAdminHomeImport } from './routes/$lang.$companyId/admin/home'
import { Route as LangCompanyIdAdminEvaluationsImport } from './routes/$lang.$companyId/admin/evaluations'
import { Route as LangCompanyIdContactIdProfileImport } from './routes/$lang.$companyId/$contactId/profile'
import { Route as LangCompanyIdContactIdPreferenceCenterImport } from './routes/$lang.$companyId/$contactId/preference-center'
import { Route as LangCompanyIdContactIdContactImport } from './routes/$lang.$companyId/$contactId/contact'
import { Route as LangCompanyIdPublicDemoIndexImport } from './routes/$lang.$companyId/public/demo/index'
import { Route as LangCompanyIdPublicValiantValiantDeviceIdImport } from './routes/$lang.$companyId/public/valiant.$valiantDeviceId'
import { Route as LangCompanyIdPublicAuthWaitlistImport } from './routes/$lang.$companyId/public/auth/waitlist'
import { Route as LangCompanyIdPublicAuthRegisterImport } from './routes/$lang.$companyId/public/auth/register'
import { Route as LangCompanyIdPublicAuthLoginImport } from './routes/$lang.$companyId/public/auth/login'
import { Route as LangCompanyIdPartnerExternalReferenceResultImport } from './routes/$lang.$companyId/partner.$externalReference/result'
import { Route as LangCompanyIdPublicEvaluationResultSessionIdImport } from './routes/$lang.$companyId/public/evaluation.result.$sessionId'
import { Route as LangCompanyIdPublicDemoDossierRegionImport } from './routes/$lang.$companyId/public/demo/dossier/region'
import { Route as LangCompanyIdPublicDemoDossierMarketImport } from './routes/$lang.$companyId/public/demo/dossier/market'
import { Route as LangCompanyIdPublicDemoDossierHomeImport } from './routes/$lang.$companyId/public/demo/dossier/home'
import { Route as LangCompanyIdPublicDemoDossierEvaluationImport } from './routes/$lang.$companyId/public/demo/dossier/evaluation'
import { Route as LangCompanyIdPublicDemoCockpitStatisticsImport } from './routes/$lang.$companyId/public/demo/cockpit/statistics'
import { Route as LangCompanyIdPublicDemoCockpitOffersImport } from './routes/$lang.$companyId/public/demo/cockpit/offers'
import { Route as LangCompanyIdPublicDemoCockpitInterestImport } from './routes/$lang.$companyId/public/demo/cockpit/interest'
import { Route as LangCompanyIdPublicDemoCockpitHomeImport } from './routes/$lang.$companyId/public/demo/cockpit/home'
import { Route as LangCompanyIdPublicDemoCockpitDocumentsImport } from './routes/$lang.$companyId/public/demo/cockpit/documents'
import { Route as LangCompanyIdPublicDemoCockpitCalendarImport } from './routes/$lang.$companyId/public/demo/cockpit/calendar'
import { Route as LangCompanyIdPublicDemoCockpitActivitiesImport } from './routes/$lang.$companyId/public/demo/cockpit/activities'
import { Route as LangCompanyIdContactIdDossierDossierIdRegionImport } from './routes/$lang.$companyId/$contactId/dossier.$dossierId/region'
import { Route as LangCompanyIdContactIdDossierDossierIdMarketImport } from './routes/$lang.$companyId/$contactId/dossier.$dossierId/market'
import { Route as LangCompanyIdContactIdDossierDossierIdHomeImport } from './routes/$lang.$companyId/$contactId/dossier.$dossierId/home'
import { Route as LangCompanyIdContactIdDossierDossierIdEvaluationImport } from './routes/$lang.$companyId/$contactId/dossier.$dossierId/evaluation'
import { Route as LangCompanyIdContactIdCockpitPropertyIdStatisticsImport } from './routes/$lang.$companyId/$contactId/cockpit.$propertyId/statistics'
import { Route as LangCompanyIdContactIdCockpitPropertyIdOffersImport } from './routes/$lang.$companyId/$contactId/cockpit.$propertyId/offers'
import { Route as LangCompanyIdContactIdCockpitPropertyIdInterestImport } from './routes/$lang.$companyId/$contactId/cockpit.$propertyId/interest'
import { Route as LangCompanyIdContactIdCockpitPropertyIdHomeImport } from './routes/$lang.$companyId/$contactId/cockpit.$propertyId/home'
import { Route as LangCompanyIdContactIdCockpitPropertyIdDocumentsImport } from './routes/$lang.$companyId/$contactId/cockpit.$propertyId/documents'
import { Route as LangCompanyIdContactIdCockpitPropertyIdCalendarImport } from './routes/$lang.$companyId/$contactId/cockpit.$propertyId/calendar'
import { Route as LangCompanyIdContactIdCockpitPropertyIdActivitiesImport } from './routes/$lang.$companyId/$contactId/cockpit.$propertyId/activities'
import { Route as LangCompanyIdPublicExposeContactIdPropertyIdViewImport } from './routes/$lang.$companyId/public/expose/$contactId.$propertyId.view'
import { Route as LangCompanyIdPublicExposeContactIdPropertyIdBookImport } from './routes/$lang.$companyId/public/expose/$contactId.$propertyId.book'
import { Route as LangCompanyIdContactIdDossierDossierIdPropertyEditImport } from './routes/$lang.$companyId/$contactId/dossier.$dossierId/property.edit'
import { Route as LangCompanyIdContactIdDossierDossierIdPropertyQualitiesEditImport } from './routes/$lang.$companyId/$contactId/dossier.$dossierId/property.qualities.edit'
import { Route as LangCompanyIdContactIdDossierDossierIdPropertyConditionEditImport } from './routes/$lang.$companyId/$contactId/dossier.$dossierId/property.condition.edit'

// Create/Update Routes

const ValiantRoute = ValiantImport.update({
  id: '/valiant',
  path: '/valiant',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthSuccessRoute = AuthSuccessImport.update({
  id: '/auth/success',
  path: '/auth/success',
  getParentRoute: () => rootRoute,
} as any)

const AuthOauthRoute = AuthOauthImport.update({
  id: '/auth/oauth',
  path: '/auth/oauth',
  getParentRoute: () => rootRoute,
} as any)

const AuthFailureRoute = AuthFailureImport.update({
  id: '/auth/failure',
  path: '/auth/failure',
  getParentRoute: () => rootRoute,
} as any)

const LangCompanyIdIndexRoute = LangCompanyIdIndexImport.update({
  id: '/$lang/$companyId/',
  path: '/$lang/$companyId/',
  getParentRoute: () => rootRoute,
} as any)

const SsoCallbackProviderRoute = SsoCallbackProviderImport.update({
  id: '/sso/callback/$provider',
  path: '/sso/callback/$provider',
  getParentRoute: () => rootRoute,
} as any)

const LangCompanyIdContactIdIndexRoute =
  LangCompanyIdContactIdIndexImport.update({
    id: '/$lang/$companyId/$contactId/',
    path: '/$lang/$companyId/$contactId/',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicSalesCallSessionRoute =
  LangCompanyIdPublicSalesCallSessionImport.update({
    id: '/$lang/$companyId/public/sales-call-session',
    path: '/$lang/$companyId/public/sales-call-session',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicContactRoute = LangCompanyIdPublicContactImport.update(
  {
    id: '/$lang/$companyId/public/contact',
    path: '/$lang/$companyId/public/contact',
    getParentRoute: () => rootRoute,
  } as any,
)

const LangCompanyIdAdminUsersRoute = LangCompanyIdAdminUsersImport.update({
  id: '/$lang/$companyId/admin/users',
  path: '/$lang/$companyId/admin/users',
  getParentRoute: () => rootRoute,
} as any)

const LangCompanyIdAdminHomeRoute = LangCompanyIdAdminHomeImport.update({
  id: '/$lang/$companyId/admin/home',
  path: '/$lang/$companyId/admin/home',
  getParentRoute: () => rootRoute,
} as any)

const LangCompanyIdAdminEvaluationsRoute =
  LangCompanyIdAdminEvaluationsImport.update({
    id: '/$lang/$companyId/admin/evaluations',
    path: '/$lang/$companyId/admin/evaluations',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdProfileRoute =
  LangCompanyIdContactIdProfileImport.update({
    id: '/$lang/$companyId/$contactId/profile',
    path: '/$lang/$companyId/$contactId/profile',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdPreferenceCenterRoute =
  LangCompanyIdContactIdPreferenceCenterImport.update({
    id: '/$lang/$companyId/$contactId/preference-center',
    path: '/$lang/$companyId/$contactId/preference-center',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdContactRoute =
  LangCompanyIdContactIdContactImport.update({
    id: '/$lang/$companyId/$contactId/contact',
    path: '/$lang/$companyId/$contactId/contact',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoIndexRoute =
  LangCompanyIdPublicDemoIndexImport.update({
    id: '/$lang/$companyId/public/demo/',
    path: '/$lang/$companyId/public/demo/',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicValiantValiantDeviceIdRoute =
  LangCompanyIdPublicValiantValiantDeviceIdImport.update({
    id: '/$lang/$companyId/public/valiant/$valiantDeviceId',
    path: '/$lang/$companyId/public/valiant/$valiantDeviceId',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicAuthWaitlistRoute =
  LangCompanyIdPublicAuthWaitlistImport.update({
    id: '/$lang/$companyId/public/auth/waitlist',
    path: '/$lang/$companyId/public/auth/waitlist',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicAuthRegisterRoute =
  LangCompanyIdPublicAuthRegisterImport.update({
    id: '/$lang/$companyId/public/auth/register',
    path: '/$lang/$companyId/public/auth/register',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicAuthLoginRoute =
  LangCompanyIdPublicAuthLoginImport.update({
    id: '/$lang/$companyId/public/auth/login',
    path: '/$lang/$companyId/public/auth/login',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPartnerExternalReferenceResultRoute =
  LangCompanyIdPartnerExternalReferenceResultImport.update({
    id: '/$lang/$companyId/partner/$externalReference/result',
    path: '/$lang/$companyId/partner/$externalReference/result',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicEvaluationResultSessionIdRoute =
  LangCompanyIdPublicEvaluationResultSessionIdImport.update({
    id: '/$lang/$companyId/public/evaluation/result/$sessionId',
    path: '/$lang/$companyId/public/evaluation/result/$sessionId',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoDossierRegionRoute =
  LangCompanyIdPublicDemoDossierRegionImport.update({
    id: '/$lang/$companyId/public/demo/dossier/region',
    path: '/$lang/$companyId/public/demo/dossier/region',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoDossierMarketRoute =
  LangCompanyIdPublicDemoDossierMarketImport.update({
    id: '/$lang/$companyId/public/demo/dossier/market',
    path: '/$lang/$companyId/public/demo/dossier/market',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoDossierHomeRoute =
  LangCompanyIdPublicDemoDossierHomeImport.update({
    id: '/$lang/$companyId/public/demo/dossier/home',
    path: '/$lang/$companyId/public/demo/dossier/home',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoDossierEvaluationRoute =
  LangCompanyIdPublicDemoDossierEvaluationImport.update({
    id: '/$lang/$companyId/public/demo/dossier/evaluation',
    path: '/$lang/$companyId/public/demo/dossier/evaluation',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoCockpitStatisticsRoute =
  LangCompanyIdPublicDemoCockpitStatisticsImport.update({
    id: '/$lang/$companyId/public/demo/cockpit/statistics',
    path: '/$lang/$companyId/public/demo/cockpit/statistics',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoCockpitOffersRoute =
  LangCompanyIdPublicDemoCockpitOffersImport.update({
    id: '/$lang/$companyId/public/demo/cockpit/offers',
    path: '/$lang/$companyId/public/demo/cockpit/offers',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoCockpitInterestRoute =
  LangCompanyIdPublicDemoCockpitInterestImport.update({
    id: '/$lang/$companyId/public/demo/cockpit/interest',
    path: '/$lang/$companyId/public/demo/cockpit/interest',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoCockpitHomeRoute =
  LangCompanyIdPublicDemoCockpitHomeImport.update({
    id: '/$lang/$companyId/public/demo/cockpit/home',
    path: '/$lang/$companyId/public/demo/cockpit/home',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoCockpitDocumentsRoute =
  LangCompanyIdPublicDemoCockpitDocumentsImport.update({
    id: '/$lang/$companyId/public/demo/cockpit/documents',
    path: '/$lang/$companyId/public/demo/cockpit/documents',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoCockpitCalendarRoute =
  LangCompanyIdPublicDemoCockpitCalendarImport.update({
    id: '/$lang/$companyId/public/demo/cockpit/calendar',
    path: '/$lang/$companyId/public/demo/cockpit/calendar',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicDemoCockpitActivitiesRoute =
  LangCompanyIdPublicDemoCockpitActivitiesImport.update({
    id: '/$lang/$companyId/public/demo/cockpit/activities',
    path: '/$lang/$companyId/public/demo/cockpit/activities',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdDossierDossierIdRegionRoute =
  LangCompanyIdContactIdDossierDossierIdRegionImport.update({
    id: '/$lang/$companyId/$contactId/dossier/$dossierId/region',
    path: '/$lang/$companyId/$contactId/dossier/$dossierId/region',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdDossierDossierIdMarketRoute =
  LangCompanyIdContactIdDossierDossierIdMarketImport.update({
    id: '/$lang/$companyId/$contactId/dossier/$dossierId/market',
    path: '/$lang/$companyId/$contactId/dossier/$dossierId/market',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdDossierDossierIdHomeRoute =
  LangCompanyIdContactIdDossierDossierIdHomeImport.update({
    id: '/$lang/$companyId/$contactId/dossier/$dossierId/home',
    path: '/$lang/$companyId/$contactId/dossier/$dossierId/home',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdDossierDossierIdEvaluationRoute =
  LangCompanyIdContactIdDossierDossierIdEvaluationImport.update({
    id: '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation',
    path: '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdCockpitPropertyIdStatisticsRoute =
  LangCompanyIdContactIdCockpitPropertyIdStatisticsImport.update({
    id: '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics',
    path: '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdCockpitPropertyIdOffersRoute =
  LangCompanyIdContactIdCockpitPropertyIdOffersImport.update({
    id: '/$lang/$companyId/$contactId/cockpit/$propertyId/offers',
    path: '/$lang/$companyId/$contactId/cockpit/$propertyId/offers',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdCockpitPropertyIdInterestRoute =
  LangCompanyIdContactIdCockpitPropertyIdInterestImport.update({
    id: '/$lang/$companyId/$contactId/cockpit/$propertyId/interest',
    path: '/$lang/$companyId/$contactId/cockpit/$propertyId/interest',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdCockpitPropertyIdHomeRoute =
  LangCompanyIdContactIdCockpitPropertyIdHomeImport.update({
    id: '/$lang/$companyId/$contactId/cockpit/$propertyId/home',
    path: '/$lang/$companyId/$contactId/cockpit/$propertyId/home',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdCockpitPropertyIdDocumentsRoute =
  LangCompanyIdContactIdCockpitPropertyIdDocumentsImport.update({
    id: '/$lang/$companyId/$contactId/cockpit/$propertyId/documents',
    path: '/$lang/$companyId/$contactId/cockpit/$propertyId/documents',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdCockpitPropertyIdCalendarRoute =
  LangCompanyIdContactIdCockpitPropertyIdCalendarImport.update({
    id: '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar',
    path: '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdCockpitPropertyIdActivitiesRoute =
  LangCompanyIdContactIdCockpitPropertyIdActivitiesImport.update({
    id: '/$lang/$companyId/$contactId/cockpit/$propertyId/activities',
    path: '/$lang/$companyId/$contactId/cockpit/$propertyId/activities',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicExposeContactIdPropertyIdViewRoute =
  LangCompanyIdPublicExposeContactIdPropertyIdViewImport.update({
    id: '/$lang/$companyId/public/expose/$contactId/$propertyId/view',
    path: '/$lang/$companyId/public/expose/$contactId/$propertyId/view',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdPublicExposeContactIdPropertyIdBookRoute =
  LangCompanyIdPublicExposeContactIdPropertyIdBookImport.update({
    id: '/$lang/$companyId/public/expose/$contactId/$propertyId/book',
    path: '/$lang/$companyId/public/expose/$contactId/$propertyId/book',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdDossierDossierIdPropertyEditRoute =
  LangCompanyIdContactIdDossierDossierIdPropertyEditImport.update({
    id: '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit',
    path: '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdDossierDossierIdPropertyQualitiesEditRoute =
  LangCompanyIdContactIdDossierDossierIdPropertyQualitiesEditImport.update({
    id: '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit',
    path: '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit',
    getParentRoute: () => rootRoute,
  } as any)

const LangCompanyIdContactIdDossierDossierIdPropertyConditionEditRoute =
  LangCompanyIdContactIdDossierDossierIdPropertyConditionEditImport.update({
    id: '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit',
    path: '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/valiant': {
      id: '/valiant'
      path: '/valiant'
      fullPath: '/valiant'
      preLoaderRoute: typeof ValiantImport
      parentRoute: typeof rootRoute
    }
    '/auth/failure': {
      id: '/auth/failure'
      path: '/auth/failure'
      fullPath: '/auth/failure'
      preLoaderRoute: typeof AuthFailureImport
      parentRoute: typeof rootRoute
    }
    '/auth/oauth': {
      id: '/auth/oauth'
      path: '/auth/oauth'
      fullPath: '/auth/oauth'
      preLoaderRoute: typeof AuthOauthImport
      parentRoute: typeof rootRoute
    }
    '/auth/success': {
      id: '/auth/success'
      path: '/auth/success'
      fullPath: '/auth/success'
      preLoaderRoute: typeof AuthSuccessImport
      parentRoute: typeof rootRoute
    }
    '/sso/callback/$provider': {
      id: '/sso/callback/$provider'
      path: '/sso/callback/$provider'
      fullPath: '/sso/callback/$provider'
      preLoaderRoute: typeof SsoCallbackProviderImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/': {
      id: '/$lang/$companyId/'
      path: '/$lang/$companyId'
      fullPath: '/$lang/$companyId'
      preLoaderRoute: typeof LangCompanyIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/contact': {
      id: '/$lang/$companyId/$contactId/contact'
      path: '/$lang/$companyId/$contactId/contact'
      fullPath: '/$lang/$companyId/$contactId/contact'
      preLoaderRoute: typeof LangCompanyIdContactIdContactImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/preference-center': {
      id: '/$lang/$companyId/$contactId/preference-center'
      path: '/$lang/$companyId/$contactId/preference-center'
      fullPath: '/$lang/$companyId/$contactId/preference-center'
      preLoaderRoute: typeof LangCompanyIdContactIdPreferenceCenterImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/profile': {
      id: '/$lang/$companyId/$contactId/profile'
      path: '/$lang/$companyId/$contactId/profile'
      fullPath: '/$lang/$companyId/$contactId/profile'
      preLoaderRoute: typeof LangCompanyIdContactIdProfileImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/admin/evaluations': {
      id: '/$lang/$companyId/admin/evaluations'
      path: '/$lang/$companyId/admin/evaluations'
      fullPath: '/$lang/$companyId/admin/evaluations'
      preLoaderRoute: typeof LangCompanyIdAdminEvaluationsImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/admin/home': {
      id: '/$lang/$companyId/admin/home'
      path: '/$lang/$companyId/admin/home'
      fullPath: '/$lang/$companyId/admin/home'
      preLoaderRoute: typeof LangCompanyIdAdminHomeImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/admin/users': {
      id: '/$lang/$companyId/admin/users'
      path: '/$lang/$companyId/admin/users'
      fullPath: '/$lang/$companyId/admin/users'
      preLoaderRoute: typeof LangCompanyIdAdminUsersImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/contact': {
      id: '/$lang/$companyId/public/contact'
      path: '/$lang/$companyId/public/contact'
      fullPath: '/$lang/$companyId/public/contact'
      preLoaderRoute: typeof LangCompanyIdPublicContactImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/sales-call-session': {
      id: '/$lang/$companyId/public/sales-call-session'
      path: '/$lang/$companyId/public/sales-call-session'
      fullPath: '/$lang/$companyId/public/sales-call-session'
      preLoaderRoute: typeof LangCompanyIdPublicSalesCallSessionImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/': {
      id: '/$lang/$companyId/$contactId/'
      path: '/$lang/$companyId/$contactId'
      fullPath: '/$lang/$companyId/$contactId'
      preLoaderRoute: typeof LangCompanyIdContactIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/partner/$externalReference/result': {
      id: '/$lang/$companyId/partner/$externalReference/result'
      path: '/$lang/$companyId/partner/$externalReference/result'
      fullPath: '/$lang/$companyId/partner/$externalReference/result'
      preLoaderRoute: typeof LangCompanyIdPartnerExternalReferenceResultImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/auth/login': {
      id: '/$lang/$companyId/public/auth/login'
      path: '/$lang/$companyId/public/auth/login'
      fullPath: '/$lang/$companyId/public/auth/login'
      preLoaderRoute: typeof LangCompanyIdPublicAuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/auth/register': {
      id: '/$lang/$companyId/public/auth/register'
      path: '/$lang/$companyId/public/auth/register'
      fullPath: '/$lang/$companyId/public/auth/register'
      preLoaderRoute: typeof LangCompanyIdPublicAuthRegisterImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/auth/waitlist': {
      id: '/$lang/$companyId/public/auth/waitlist'
      path: '/$lang/$companyId/public/auth/waitlist'
      fullPath: '/$lang/$companyId/public/auth/waitlist'
      preLoaderRoute: typeof LangCompanyIdPublicAuthWaitlistImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/valiant/$valiantDeviceId': {
      id: '/$lang/$companyId/public/valiant/$valiantDeviceId'
      path: '/$lang/$companyId/public/valiant/$valiantDeviceId'
      fullPath: '/$lang/$companyId/public/valiant/$valiantDeviceId'
      preLoaderRoute: typeof LangCompanyIdPublicValiantValiantDeviceIdImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/': {
      id: '/$lang/$companyId/public/demo/'
      path: '/$lang/$companyId/public/demo'
      fullPath: '/$lang/$companyId/public/demo'
      preLoaderRoute: typeof LangCompanyIdPublicDemoIndexImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/cockpit/$propertyId/activities': {
      id: '/$lang/$companyId/$contactId/cockpit/$propertyId/activities'
      path: '/$lang/$companyId/$contactId/cockpit/$propertyId/activities'
      fullPath: '/$lang/$companyId/$contactId/cockpit/$propertyId/activities'
      preLoaderRoute: typeof LangCompanyIdContactIdCockpitPropertyIdActivitiesImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar': {
      id: '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar'
      path: '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar'
      fullPath: '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar'
      preLoaderRoute: typeof LangCompanyIdContactIdCockpitPropertyIdCalendarImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/cockpit/$propertyId/documents': {
      id: '/$lang/$companyId/$contactId/cockpit/$propertyId/documents'
      path: '/$lang/$companyId/$contactId/cockpit/$propertyId/documents'
      fullPath: '/$lang/$companyId/$contactId/cockpit/$propertyId/documents'
      preLoaderRoute: typeof LangCompanyIdContactIdCockpitPropertyIdDocumentsImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/cockpit/$propertyId/home': {
      id: '/$lang/$companyId/$contactId/cockpit/$propertyId/home'
      path: '/$lang/$companyId/$contactId/cockpit/$propertyId/home'
      fullPath: '/$lang/$companyId/$contactId/cockpit/$propertyId/home'
      preLoaderRoute: typeof LangCompanyIdContactIdCockpitPropertyIdHomeImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/cockpit/$propertyId/interest': {
      id: '/$lang/$companyId/$contactId/cockpit/$propertyId/interest'
      path: '/$lang/$companyId/$contactId/cockpit/$propertyId/interest'
      fullPath: '/$lang/$companyId/$contactId/cockpit/$propertyId/interest'
      preLoaderRoute: typeof LangCompanyIdContactIdCockpitPropertyIdInterestImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/cockpit/$propertyId/offers': {
      id: '/$lang/$companyId/$contactId/cockpit/$propertyId/offers'
      path: '/$lang/$companyId/$contactId/cockpit/$propertyId/offers'
      fullPath: '/$lang/$companyId/$contactId/cockpit/$propertyId/offers'
      preLoaderRoute: typeof LangCompanyIdContactIdCockpitPropertyIdOffersImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics': {
      id: '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics'
      path: '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics'
      fullPath: '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics'
      preLoaderRoute: typeof LangCompanyIdContactIdCockpitPropertyIdStatisticsImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation': {
      id: '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation'
      path: '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation'
      fullPath: '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation'
      preLoaderRoute: typeof LangCompanyIdContactIdDossierDossierIdEvaluationImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/dossier/$dossierId/home': {
      id: '/$lang/$companyId/$contactId/dossier/$dossierId/home'
      path: '/$lang/$companyId/$contactId/dossier/$dossierId/home'
      fullPath: '/$lang/$companyId/$contactId/dossier/$dossierId/home'
      preLoaderRoute: typeof LangCompanyIdContactIdDossierDossierIdHomeImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/dossier/$dossierId/market': {
      id: '/$lang/$companyId/$contactId/dossier/$dossierId/market'
      path: '/$lang/$companyId/$contactId/dossier/$dossierId/market'
      fullPath: '/$lang/$companyId/$contactId/dossier/$dossierId/market'
      preLoaderRoute: typeof LangCompanyIdContactIdDossierDossierIdMarketImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/dossier/$dossierId/region': {
      id: '/$lang/$companyId/$contactId/dossier/$dossierId/region'
      path: '/$lang/$companyId/$contactId/dossier/$dossierId/region'
      fullPath: '/$lang/$companyId/$contactId/dossier/$dossierId/region'
      preLoaderRoute: typeof LangCompanyIdContactIdDossierDossierIdRegionImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/cockpit/activities': {
      id: '/$lang/$companyId/public/demo/cockpit/activities'
      path: '/$lang/$companyId/public/demo/cockpit/activities'
      fullPath: '/$lang/$companyId/public/demo/cockpit/activities'
      preLoaderRoute: typeof LangCompanyIdPublicDemoCockpitActivitiesImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/cockpit/calendar': {
      id: '/$lang/$companyId/public/demo/cockpit/calendar'
      path: '/$lang/$companyId/public/demo/cockpit/calendar'
      fullPath: '/$lang/$companyId/public/demo/cockpit/calendar'
      preLoaderRoute: typeof LangCompanyIdPublicDemoCockpitCalendarImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/cockpit/documents': {
      id: '/$lang/$companyId/public/demo/cockpit/documents'
      path: '/$lang/$companyId/public/demo/cockpit/documents'
      fullPath: '/$lang/$companyId/public/demo/cockpit/documents'
      preLoaderRoute: typeof LangCompanyIdPublicDemoCockpitDocumentsImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/cockpit/home': {
      id: '/$lang/$companyId/public/demo/cockpit/home'
      path: '/$lang/$companyId/public/demo/cockpit/home'
      fullPath: '/$lang/$companyId/public/demo/cockpit/home'
      preLoaderRoute: typeof LangCompanyIdPublicDemoCockpitHomeImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/cockpit/interest': {
      id: '/$lang/$companyId/public/demo/cockpit/interest'
      path: '/$lang/$companyId/public/demo/cockpit/interest'
      fullPath: '/$lang/$companyId/public/demo/cockpit/interest'
      preLoaderRoute: typeof LangCompanyIdPublicDemoCockpitInterestImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/cockpit/offers': {
      id: '/$lang/$companyId/public/demo/cockpit/offers'
      path: '/$lang/$companyId/public/demo/cockpit/offers'
      fullPath: '/$lang/$companyId/public/demo/cockpit/offers'
      preLoaderRoute: typeof LangCompanyIdPublicDemoCockpitOffersImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/cockpit/statistics': {
      id: '/$lang/$companyId/public/demo/cockpit/statistics'
      path: '/$lang/$companyId/public/demo/cockpit/statistics'
      fullPath: '/$lang/$companyId/public/demo/cockpit/statistics'
      preLoaderRoute: typeof LangCompanyIdPublicDemoCockpitStatisticsImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/dossier/evaluation': {
      id: '/$lang/$companyId/public/demo/dossier/evaluation'
      path: '/$lang/$companyId/public/demo/dossier/evaluation'
      fullPath: '/$lang/$companyId/public/demo/dossier/evaluation'
      preLoaderRoute: typeof LangCompanyIdPublicDemoDossierEvaluationImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/dossier/home': {
      id: '/$lang/$companyId/public/demo/dossier/home'
      path: '/$lang/$companyId/public/demo/dossier/home'
      fullPath: '/$lang/$companyId/public/demo/dossier/home'
      preLoaderRoute: typeof LangCompanyIdPublicDemoDossierHomeImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/dossier/market': {
      id: '/$lang/$companyId/public/demo/dossier/market'
      path: '/$lang/$companyId/public/demo/dossier/market'
      fullPath: '/$lang/$companyId/public/demo/dossier/market'
      preLoaderRoute: typeof LangCompanyIdPublicDemoDossierMarketImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/demo/dossier/region': {
      id: '/$lang/$companyId/public/demo/dossier/region'
      path: '/$lang/$companyId/public/demo/dossier/region'
      fullPath: '/$lang/$companyId/public/demo/dossier/region'
      preLoaderRoute: typeof LangCompanyIdPublicDemoDossierRegionImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/evaluation/result/$sessionId': {
      id: '/$lang/$companyId/public/evaluation/result/$sessionId'
      path: '/$lang/$companyId/public/evaluation/result/$sessionId'
      fullPath: '/$lang/$companyId/public/evaluation/result/$sessionId'
      preLoaderRoute: typeof LangCompanyIdPublicEvaluationResultSessionIdImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit': {
      id: '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit'
      path: '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit'
      fullPath: '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit'
      preLoaderRoute: typeof LangCompanyIdContactIdDossierDossierIdPropertyEditImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/expose/$contactId/$propertyId/book': {
      id: '/$lang/$companyId/public/expose/$contactId/$propertyId/book'
      path: '/$lang/$companyId/public/expose/$contactId/$propertyId/book'
      fullPath: '/$lang/$companyId/public/expose/$contactId/$propertyId/book'
      preLoaderRoute: typeof LangCompanyIdPublicExposeContactIdPropertyIdBookImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/public/expose/$contactId/$propertyId/view': {
      id: '/$lang/$companyId/public/expose/$contactId/$propertyId/view'
      path: '/$lang/$companyId/public/expose/$contactId/$propertyId/view'
      fullPath: '/$lang/$companyId/public/expose/$contactId/$propertyId/view'
      preLoaderRoute: typeof LangCompanyIdPublicExposeContactIdPropertyIdViewImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit': {
      id: '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit'
      path: '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit'
      fullPath: '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit'
      preLoaderRoute: typeof LangCompanyIdContactIdDossierDossierIdPropertyConditionEditImport
      parentRoute: typeof rootRoute
    }
    '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit': {
      id: '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit'
      path: '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit'
      fullPath: '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit'
      preLoaderRoute: typeof LangCompanyIdContactIdDossierDossierIdPropertyQualitiesEditImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/valiant': typeof ValiantRoute
  '/auth/failure': typeof AuthFailureRoute
  '/auth/oauth': typeof AuthOauthRoute
  '/auth/success': typeof AuthSuccessRoute
  '/sso/callback/$provider': typeof SsoCallbackProviderRoute
  '/$lang/$companyId': typeof LangCompanyIdIndexRoute
  '/$lang/$companyId/$contactId/contact': typeof LangCompanyIdContactIdContactRoute
  '/$lang/$companyId/$contactId/preference-center': typeof LangCompanyIdContactIdPreferenceCenterRoute
  '/$lang/$companyId/$contactId/profile': typeof LangCompanyIdContactIdProfileRoute
  '/$lang/$companyId/admin/evaluations': typeof LangCompanyIdAdminEvaluationsRoute
  '/$lang/$companyId/admin/home': typeof LangCompanyIdAdminHomeRoute
  '/$lang/$companyId/admin/users': typeof LangCompanyIdAdminUsersRoute
  '/$lang/$companyId/public/contact': typeof LangCompanyIdPublicContactRoute
  '/$lang/$companyId/public/sales-call-session': typeof LangCompanyIdPublicSalesCallSessionRoute
  '/$lang/$companyId/$contactId': typeof LangCompanyIdContactIdIndexRoute
  '/$lang/$companyId/partner/$externalReference/result': typeof LangCompanyIdPartnerExternalReferenceResultRoute
  '/$lang/$companyId/public/auth/login': typeof LangCompanyIdPublicAuthLoginRoute
  '/$lang/$companyId/public/auth/register': typeof LangCompanyIdPublicAuthRegisterRoute
  '/$lang/$companyId/public/auth/waitlist': typeof LangCompanyIdPublicAuthWaitlistRoute
  '/$lang/$companyId/public/valiant/$valiantDeviceId': typeof LangCompanyIdPublicValiantValiantDeviceIdRoute
  '/$lang/$companyId/public/demo': typeof LangCompanyIdPublicDemoIndexRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/activities': typeof LangCompanyIdContactIdCockpitPropertyIdActivitiesRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar': typeof LangCompanyIdContactIdCockpitPropertyIdCalendarRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/documents': typeof LangCompanyIdContactIdCockpitPropertyIdDocumentsRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/home': typeof LangCompanyIdContactIdCockpitPropertyIdHomeRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/interest': typeof LangCompanyIdContactIdCockpitPropertyIdInterestRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/offers': typeof LangCompanyIdContactIdCockpitPropertyIdOffersRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics': typeof LangCompanyIdContactIdCockpitPropertyIdStatisticsRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation': typeof LangCompanyIdContactIdDossierDossierIdEvaluationRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/home': typeof LangCompanyIdContactIdDossierDossierIdHomeRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/market': typeof LangCompanyIdContactIdDossierDossierIdMarketRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/region': typeof LangCompanyIdContactIdDossierDossierIdRegionRoute
  '/$lang/$companyId/public/demo/cockpit/activities': typeof LangCompanyIdPublicDemoCockpitActivitiesRoute
  '/$lang/$companyId/public/demo/cockpit/calendar': typeof LangCompanyIdPublicDemoCockpitCalendarRoute
  '/$lang/$companyId/public/demo/cockpit/documents': typeof LangCompanyIdPublicDemoCockpitDocumentsRoute
  '/$lang/$companyId/public/demo/cockpit/home': typeof LangCompanyIdPublicDemoCockpitHomeRoute
  '/$lang/$companyId/public/demo/cockpit/interest': typeof LangCompanyIdPublicDemoCockpitInterestRoute
  '/$lang/$companyId/public/demo/cockpit/offers': typeof LangCompanyIdPublicDemoCockpitOffersRoute
  '/$lang/$companyId/public/demo/cockpit/statistics': typeof LangCompanyIdPublicDemoCockpitStatisticsRoute
  '/$lang/$companyId/public/demo/dossier/evaluation': typeof LangCompanyIdPublicDemoDossierEvaluationRoute
  '/$lang/$companyId/public/demo/dossier/home': typeof LangCompanyIdPublicDemoDossierHomeRoute
  '/$lang/$companyId/public/demo/dossier/market': typeof LangCompanyIdPublicDemoDossierMarketRoute
  '/$lang/$companyId/public/demo/dossier/region': typeof LangCompanyIdPublicDemoDossierRegionRoute
  '/$lang/$companyId/public/evaluation/result/$sessionId': typeof LangCompanyIdPublicEvaluationResultSessionIdRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit': typeof LangCompanyIdContactIdDossierDossierIdPropertyEditRoute
  '/$lang/$companyId/public/expose/$contactId/$propertyId/book': typeof LangCompanyIdPublicExposeContactIdPropertyIdBookRoute
  '/$lang/$companyId/public/expose/$contactId/$propertyId/view': typeof LangCompanyIdPublicExposeContactIdPropertyIdViewRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit': typeof LangCompanyIdContactIdDossierDossierIdPropertyConditionEditRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit': typeof LangCompanyIdContactIdDossierDossierIdPropertyQualitiesEditRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/valiant': typeof ValiantRoute
  '/auth/failure': typeof AuthFailureRoute
  '/auth/oauth': typeof AuthOauthRoute
  '/auth/success': typeof AuthSuccessRoute
  '/sso/callback/$provider': typeof SsoCallbackProviderRoute
  '/$lang/$companyId': typeof LangCompanyIdIndexRoute
  '/$lang/$companyId/$contactId/contact': typeof LangCompanyIdContactIdContactRoute
  '/$lang/$companyId/$contactId/preference-center': typeof LangCompanyIdContactIdPreferenceCenterRoute
  '/$lang/$companyId/$contactId/profile': typeof LangCompanyIdContactIdProfileRoute
  '/$lang/$companyId/admin/evaluations': typeof LangCompanyIdAdminEvaluationsRoute
  '/$lang/$companyId/admin/home': typeof LangCompanyIdAdminHomeRoute
  '/$lang/$companyId/admin/users': typeof LangCompanyIdAdminUsersRoute
  '/$lang/$companyId/public/contact': typeof LangCompanyIdPublicContactRoute
  '/$lang/$companyId/public/sales-call-session': typeof LangCompanyIdPublicSalesCallSessionRoute
  '/$lang/$companyId/$contactId': typeof LangCompanyIdContactIdIndexRoute
  '/$lang/$companyId/partner/$externalReference/result': typeof LangCompanyIdPartnerExternalReferenceResultRoute
  '/$lang/$companyId/public/auth/login': typeof LangCompanyIdPublicAuthLoginRoute
  '/$lang/$companyId/public/auth/register': typeof LangCompanyIdPublicAuthRegisterRoute
  '/$lang/$companyId/public/auth/waitlist': typeof LangCompanyIdPublicAuthWaitlistRoute
  '/$lang/$companyId/public/valiant/$valiantDeviceId': typeof LangCompanyIdPublicValiantValiantDeviceIdRoute
  '/$lang/$companyId/public/demo': typeof LangCompanyIdPublicDemoIndexRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/activities': typeof LangCompanyIdContactIdCockpitPropertyIdActivitiesRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar': typeof LangCompanyIdContactIdCockpitPropertyIdCalendarRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/documents': typeof LangCompanyIdContactIdCockpitPropertyIdDocumentsRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/home': typeof LangCompanyIdContactIdCockpitPropertyIdHomeRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/interest': typeof LangCompanyIdContactIdCockpitPropertyIdInterestRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/offers': typeof LangCompanyIdContactIdCockpitPropertyIdOffersRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics': typeof LangCompanyIdContactIdCockpitPropertyIdStatisticsRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation': typeof LangCompanyIdContactIdDossierDossierIdEvaluationRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/home': typeof LangCompanyIdContactIdDossierDossierIdHomeRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/market': typeof LangCompanyIdContactIdDossierDossierIdMarketRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/region': typeof LangCompanyIdContactIdDossierDossierIdRegionRoute
  '/$lang/$companyId/public/demo/cockpit/activities': typeof LangCompanyIdPublicDemoCockpitActivitiesRoute
  '/$lang/$companyId/public/demo/cockpit/calendar': typeof LangCompanyIdPublicDemoCockpitCalendarRoute
  '/$lang/$companyId/public/demo/cockpit/documents': typeof LangCompanyIdPublicDemoCockpitDocumentsRoute
  '/$lang/$companyId/public/demo/cockpit/home': typeof LangCompanyIdPublicDemoCockpitHomeRoute
  '/$lang/$companyId/public/demo/cockpit/interest': typeof LangCompanyIdPublicDemoCockpitInterestRoute
  '/$lang/$companyId/public/demo/cockpit/offers': typeof LangCompanyIdPublicDemoCockpitOffersRoute
  '/$lang/$companyId/public/demo/cockpit/statistics': typeof LangCompanyIdPublicDemoCockpitStatisticsRoute
  '/$lang/$companyId/public/demo/dossier/evaluation': typeof LangCompanyIdPublicDemoDossierEvaluationRoute
  '/$lang/$companyId/public/demo/dossier/home': typeof LangCompanyIdPublicDemoDossierHomeRoute
  '/$lang/$companyId/public/demo/dossier/market': typeof LangCompanyIdPublicDemoDossierMarketRoute
  '/$lang/$companyId/public/demo/dossier/region': typeof LangCompanyIdPublicDemoDossierRegionRoute
  '/$lang/$companyId/public/evaluation/result/$sessionId': typeof LangCompanyIdPublicEvaluationResultSessionIdRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit': typeof LangCompanyIdContactIdDossierDossierIdPropertyEditRoute
  '/$lang/$companyId/public/expose/$contactId/$propertyId/book': typeof LangCompanyIdPublicExposeContactIdPropertyIdBookRoute
  '/$lang/$companyId/public/expose/$contactId/$propertyId/view': typeof LangCompanyIdPublicExposeContactIdPropertyIdViewRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit': typeof LangCompanyIdContactIdDossierDossierIdPropertyConditionEditRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit': typeof LangCompanyIdContactIdDossierDossierIdPropertyQualitiesEditRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/valiant': typeof ValiantRoute
  '/auth/failure': typeof AuthFailureRoute
  '/auth/oauth': typeof AuthOauthRoute
  '/auth/success': typeof AuthSuccessRoute
  '/sso/callback/$provider': typeof SsoCallbackProviderRoute
  '/$lang/$companyId/': typeof LangCompanyIdIndexRoute
  '/$lang/$companyId/$contactId/contact': typeof LangCompanyIdContactIdContactRoute
  '/$lang/$companyId/$contactId/preference-center': typeof LangCompanyIdContactIdPreferenceCenterRoute
  '/$lang/$companyId/$contactId/profile': typeof LangCompanyIdContactIdProfileRoute
  '/$lang/$companyId/admin/evaluations': typeof LangCompanyIdAdminEvaluationsRoute
  '/$lang/$companyId/admin/home': typeof LangCompanyIdAdminHomeRoute
  '/$lang/$companyId/admin/users': typeof LangCompanyIdAdminUsersRoute
  '/$lang/$companyId/public/contact': typeof LangCompanyIdPublicContactRoute
  '/$lang/$companyId/public/sales-call-session': typeof LangCompanyIdPublicSalesCallSessionRoute
  '/$lang/$companyId/$contactId/': typeof LangCompanyIdContactIdIndexRoute
  '/$lang/$companyId/partner/$externalReference/result': typeof LangCompanyIdPartnerExternalReferenceResultRoute
  '/$lang/$companyId/public/auth/login': typeof LangCompanyIdPublicAuthLoginRoute
  '/$lang/$companyId/public/auth/register': typeof LangCompanyIdPublicAuthRegisterRoute
  '/$lang/$companyId/public/auth/waitlist': typeof LangCompanyIdPublicAuthWaitlistRoute
  '/$lang/$companyId/public/valiant/$valiantDeviceId': typeof LangCompanyIdPublicValiantValiantDeviceIdRoute
  '/$lang/$companyId/public/demo/': typeof LangCompanyIdPublicDemoIndexRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/activities': typeof LangCompanyIdContactIdCockpitPropertyIdActivitiesRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar': typeof LangCompanyIdContactIdCockpitPropertyIdCalendarRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/documents': typeof LangCompanyIdContactIdCockpitPropertyIdDocumentsRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/home': typeof LangCompanyIdContactIdCockpitPropertyIdHomeRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/interest': typeof LangCompanyIdContactIdCockpitPropertyIdInterestRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/offers': typeof LangCompanyIdContactIdCockpitPropertyIdOffersRoute
  '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics': typeof LangCompanyIdContactIdCockpitPropertyIdStatisticsRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation': typeof LangCompanyIdContactIdDossierDossierIdEvaluationRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/home': typeof LangCompanyIdContactIdDossierDossierIdHomeRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/market': typeof LangCompanyIdContactIdDossierDossierIdMarketRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/region': typeof LangCompanyIdContactIdDossierDossierIdRegionRoute
  '/$lang/$companyId/public/demo/cockpit/activities': typeof LangCompanyIdPublicDemoCockpitActivitiesRoute
  '/$lang/$companyId/public/demo/cockpit/calendar': typeof LangCompanyIdPublicDemoCockpitCalendarRoute
  '/$lang/$companyId/public/demo/cockpit/documents': typeof LangCompanyIdPublicDemoCockpitDocumentsRoute
  '/$lang/$companyId/public/demo/cockpit/home': typeof LangCompanyIdPublicDemoCockpitHomeRoute
  '/$lang/$companyId/public/demo/cockpit/interest': typeof LangCompanyIdPublicDemoCockpitInterestRoute
  '/$lang/$companyId/public/demo/cockpit/offers': typeof LangCompanyIdPublicDemoCockpitOffersRoute
  '/$lang/$companyId/public/demo/cockpit/statistics': typeof LangCompanyIdPublicDemoCockpitStatisticsRoute
  '/$lang/$companyId/public/demo/dossier/evaluation': typeof LangCompanyIdPublicDemoDossierEvaluationRoute
  '/$lang/$companyId/public/demo/dossier/home': typeof LangCompanyIdPublicDemoDossierHomeRoute
  '/$lang/$companyId/public/demo/dossier/market': typeof LangCompanyIdPublicDemoDossierMarketRoute
  '/$lang/$companyId/public/demo/dossier/region': typeof LangCompanyIdPublicDemoDossierRegionRoute
  '/$lang/$companyId/public/evaluation/result/$sessionId': typeof LangCompanyIdPublicEvaluationResultSessionIdRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit': typeof LangCompanyIdContactIdDossierDossierIdPropertyEditRoute
  '/$lang/$companyId/public/expose/$contactId/$propertyId/book': typeof LangCompanyIdPublicExposeContactIdPropertyIdBookRoute
  '/$lang/$companyId/public/expose/$contactId/$propertyId/view': typeof LangCompanyIdPublicExposeContactIdPropertyIdViewRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit': typeof LangCompanyIdContactIdDossierDossierIdPropertyConditionEditRoute
  '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit': typeof LangCompanyIdContactIdDossierDossierIdPropertyQualitiesEditRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/valiant'
    | '/auth/failure'
    | '/auth/oauth'
    | '/auth/success'
    | '/sso/callback/$provider'
    | '/$lang/$companyId'
    | '/$lang/$companyId/$contactId/contact'
    | '/$lang/$companyId/$contactId/preference-center'
    | '/$lang/$companyId/$contactId/profile'
    | '/$lang/$companyId/admin/evaluations'
    | '/$lang/$companyId/admin/home'
    | '/$lang/$companyId/admin/users'
    | '/$lang/$companyId/public/contact'
    | '/$lang/$companyId/public/sales-call-session'
    | '/$lang/$companyId/$contactId'
    | '/$lang/$companyId/partner/$externalReference/result'
    | '/$lang/$companyId/public/auth/login'
    | '/$lang/$companyId/public/auth/register'
    | '/$lang/$companyId/public/auth/waitlist'
    | '/$lang/$companyId/public/valiant/$valiantDeviceId'
    | '/$lang/$companyId/public/demo'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/activities'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/documents'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/home'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/interest'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/offers'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/home'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/market'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/region'
    | '/$lang/$companyId/public/demo/cockpit/activities'
    | '/$lang/$companyId/public/demo/cockpit/calendar'
    | '/$lang/$companyId/public/demo/cockpit/documents'
    | '/$lang/$companyId/public/demo/cockpit/home'
    | '/$lang/$companyId/public/demo/cockpit/interest'
    | '/$lang/$companyId/public/demo/cockpit/offers'
    | '/$lang/$companyId/public/demo/cockpit/statistics'
    | '/$lang/$companyId/public/demo/dossier/evaluation'
    | '/$lang/$companyId/public/demo/dossier/home'
    | '/$lang/$companyId/public/demo/dossier/market'
    | '/$lang/$companyId/public/demo/dossier/region'
    | '/$lang/$companyId/public/evaluation/result/$sessionId'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit'
    | '/$lang/$companyId/public/expose/$contactId/$propertyId/book'
    | '/$lang/$companyId/public/expose/$contactId/$propertyId/view'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/valiant'
    | '/auth/failure'
    | '/auth/oauth'
    | '/auth/success'
    | '/sso/callback/$provider'
    | '/$lang/$companyId'
    | '/$lang/$companyId/$contactId/contact'
    | '/$lang/$companyId/$contactId/preference-center'
    | '/$lang/$companyId/$contactId/profile'
    | '/$lang/$companyId/admin/evaluations'
    | '/$lang/$companyId/admin/home'
    | '/$lang/$companyId/admin/users'
    | '/$lang/$companyId/public/contact'
    | '/$lang/$companyId/public/sales-call-session'
    | '/$lang/$companyId/$contactId'
    | '/$lang/$companyId/partner/$externalReference/result'
    | '/$lang/$companyId/public/auth/login'
    | '/$lang/$companyId/public/auth/register'
    | '/$lang/$companyId/public/auth/waitlist'
    | '/$lang/$companyId/public/valiant/$valiantDeviceId'
    | '/$lang/$companyId/public/demo'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/activities'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/documents'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/home'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/interest'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/offers'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/home'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/market'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/region'
    | '/$lang/$companyId/public/demo/cockpit/activities'
    | '/$lang/$companyId/public/demo/cockpit/calendar'
    | '/$lang/$companyId/public/demo/cockpit/documents'
    | '/$lang/$companyId/public/demo/cockpit/home'
    | '/$lang/$companyId/public/demo/cockpit/interest'
    | '/$lang/$companyId/public/demo/cockpit/offers'
    | '/$lang/$companyId/public/demo/cockpit/statistics'
    | '/$lang/$companyId/public/demo/dossier/evaluation'
    | '/$lang/$companyId/public/demo/dossier/home'
    | '/$lang/$companyId/public/demo/dossier/market'
    | '/$lang/$companyId/public/demo/dossier/region'
    | '/$lang/$companyId/public/evaluation/result/$sessionId'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit'
    | '/$lang/$companyId/public/expose/$contactId/$propertyId/book'
    | '/$lang/$companyId/public/expose/$contactId/$propertyId/view'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit'
  id:
    | '__root__'
    | '/'
    | '/valiant'
    | '/auth/failure'
    | '/auth/oauth'
    | '/auth/success'
    | '/sso/callback/$provider'
    | '/$lang/$companyId/'
    | '/$lang/$companyId/$contactId/contact'
    | '/$lang/$companyId/$contactId/preference-center'
    | '/$lang/$companyId/$contactId/profile'
    | '/$lang/$companyId/admin/evaluations'
    | '/$lang/$companyId/admin/home'
    | '/$lang/$companyId/admin/users'
    | '/$lang/$companyId/public/contact'
    | '/$lang/$companyId/public/sales-call-session'
    | '/$lang/$companyId/$contactId/'
    | '/$lang/$companyId/partner/$externalReference/result'
    | '/$lang/$companyId/public/auth/login'
    | '/$lang/$companyId/public/auth/register'
    | '/$lang/$companyId/public/auth/waitlist'
    | '/$lang/$companyId/public/valiant/$valiantDeviceId'
    | '/$lang/$companyId/public/demo/'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/activities'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/calendar'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/documents'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/home'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/interest'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/offers'
    | '/$lang/$companyId/$contactId/cockpit/$propertyId/statistics'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/evaluation'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/home'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/market'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/region'
    | '/$lang/$companyId/public/demo/cockpit/activities'
    | '/$lang/$companyId/public/demo/cockpit/calendar'
    | '/$lang/$companyId/public/demo/cockpit/documents'
    | '/$lang/$companyId/public/demo/cockpit/home'
    | '/$lang/$companyId/public/demo/cockpit/interest'
    | '/$lang/$companyId/public/demo/cockpit/offers'
    | '/$lang/$companyId/public/demo/cockpit/statistics'
    | '/$lang/$companyId/public/demo/dossier/evaluation'
    | '/$lang/$companyId/public/demo/dossier/home'
    | '/$lang/$companyId/public/demo/dossier/market'
    | '/$lang/$companyId/public/demo/dossier/region'
    | '/$lang/$companyId/public/evaluation/result/$sessionId'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/property/edit'
    | '/$lang/$companyId/public/expose/$contactId/$propertyId/book'
    | '/$lang/$companyId/public/expose/$contactId/$propertyId/view'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit'
    | '/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ValiantRoute: typeof ValiantRoute
  AuthFailureRoute: typeof AuthFailureRoute
  AuthOauthRoute: typeof AuthOauthRoute
  AuthSuccessRoute: typeof AuthSuccessRoute
  SsoCallbackProviderRoute: typeof SsoCallbackProviderRoute
  LangCompanyIdIndexRoute: typeof LangCompanyIdIndexRoute
  LangCompanyIdContactIdContactRoute: typeof LangCompanyIdContactIdContactRoute
  LangCompanyIdContactIdPreferenceCenterRoute: typeof LangCompanyIdContactIdPreferenceCenterRoute
  LangCompanyIdContactIdProfileRoute: typeof LangCompanyIdContactIdProfileRoute
  LangCompanyIdAdminEvaluationsRoute: typeof LangCompanyIdAdminEvaluationsRoute
  LangCompanyIdAdminHomeRoute: typeof LangCompanyIdAdminHomeRoute
  LangCompanyIdAdminUsersRoute: typeof LangCompanyIdAdminUsersRoute
  LangCompanyIdPublicContactRoute: typeof LangCompanyIdPublicContactRoute
  LangCompanyIdPublicSalesCallSessionRoute: typeof LangCompanyIdPublicSalesCallSessionRoute
  LangCompanyIdContactIdIndexRoute: typeof LangCompanyIdContactIdIndexRoute
  LangCompanyIdPartnerExternalReferenceResultRoute: typeof LangCompanyIdPartnerExternalReferenceResultRoute
  LangCompanyIdPublicAuthLoginRoute: typeof LangCompanyIdPublicAuthLoginRoute
  LangCompanyIdPublicAuthRegisterRoute: typeof LangCompanyIdPublicAuthRegisterRoute
  LangCompanyIdPublicAuthWaitlistRoute: typeof LangCompanyIdPublicAuthWaitlistRoute
  LangCompanyIdPublicValiantValiantDeviceIdRoute: typeof LangCompanyIdPublicValiantValiantDeviceIdRoute
  LangCompanyIdPublicDemoIndexRoute: typeof LangCompanyIdPublicDemoIndexRoute
  LangCompanyIdContactIdCockpitPropertyIdActivitiesRoute: typeof LangCompanyIdContactIdCockpitPropertyIdActivitiesRoute
  LangCompanyIdContactIdCockpitPropertyIdCalendarRoute: typeof LangCompanyIdContactIdCockpitPropertyIdCalendarRoute
  LangCompanyIdContactIdCockpitPropertyIdDocumentsRoute: typeof LangCompanyIdContactIdCockpitPropertyIdDocumentsRoute
  LangCompanyIdContactIdCockpitPropertyIdHomeRoute: typeof LangCompanyIdContactIdCockpitPropertyIdHomeRoute
  LangCompanyIdContactIdCockpitPropertyIdInterestRoute: typeof LangCompanyIdContactIdCockpitPropertyIdInterestRoute
  LangCompanyIdContactIdCockpitPropertyIdOffersRoute: typeof LangCompanyIdContactIdCockpitPropertyIdOffersRoute
  LangCompanyIdContactIdCockpitPropertyIdStatisticsRoute: typeof LangCompanyIdContactIdCockpitPropertyIdStatisticsRoute
  LangCompanyIdContactIdDossierDossierIdEvaluationRoute: typeof LangCompanyIdContactIdDossierDossierIdEvaluationRoute
  LangCompanyIdContactIdDossierDossierIdHomeRoute: typeof LangCompanyIdContactIdDossierDossierIdHomeRoute
  LangCompanyIdContactIdDossierDossierIdMarketRoute: typeof LangCompanyIdContactIdDossierDossierIdMarketRoute
  LangCompanyIdContactIdDossierDossierIdRegionRoute: typeof LangCompanyIdContactIdDossierDossierIdRegionRoute
  LangCompanyIdPublicDemoCockpitActivitiesRoute: typeof LangCompanyIdPublicDemoCockpitActivitiesRoute
  LangCompanyIdPublicDemoCockpitCalendarRoute: typeof LangCompanyIdPublicDemoCockpitCalendarRoute
  LangCompanyIdPublicDemoCockpitDocumentsRoute: typeof LangCompanyIdPublicDemoCockpitDocumentsRoute
  LangCompanyIdPublicDemoCockpitHomeRoute: typeof LangCompanyIdPublicDemoCockpitHomeRoute
  LangCompanyIdPublicDemoCockpitInterestRoute: typeof LangCompanyIdPublicDemoCockpitInterestRoute
  LangCompanyIdPublicDemoCockpitOffersRoute: typeof LangCompanyIdPublicDemoCockpitOffersRoute
  LangCompanyIdPublicDemoCockpitStatisticsRoute: typeof LangCompanyIdPublicDemoCockpitStatisticsRoute
  LangCompanyIdPublicDemoDossierEvaluationRoute: typeof LangCompanyIdPublicDemoDossierEvaluationRoute
  LangCompanyIdPublicDemoDossierHomeRoute: typeof LangCompanyIdPublicDemoDossierHomeRoute
  LangCompanyIdPublicDemoDossierMarketRoute: typeof LangCompanyIdPublicDemoDossierMarketRoute
  LangCompanyIdPublicDemoDossierRegionRoute: typeof LangCompanyIdPublicDemoDossierRegionRoute
  LangCompanyIdPublicEvaluationResultSessionIdRoute: typeof LangCompanyIdPublicEvaluationResultSessionIdRoute
  LangCompanyIdContactIdDossierDossierIdPropertyEditRoute: typeof LangCompanyIdContactIdDossierDossierIdPropertyEditRoute
  LangCompanyIdPublicExposeContactIdPropertyIdBookRoute: typeof LangCompanyIdPublicExposeContactIdPropertyIdBookRoute
  LangCompanyIdPublicExposeContactIdPropertyIdViewRoute: typeof LangCompanyIdPublicExposeContactIdPropertyIdViewRoute
  LangCompanyIdContactIdDossierDossierIdPropertyConditionEditRoute: typeof LangCompanyIdContactIdDossierDossierIdPropertyConditionEditRoute
  LangCompanyIdContactIdDossierDossierIdPropertyQualitiesEditRoute: typeof LangCompanyIdContactIdDossierDossierIdPropertyQualitiesEditRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ValiantRoute: ValiantRoute,
  AuthFailureRoute: AuthFailureRoute,
  AuthOauthRoute: AuthOauthRoute,
  AuthSuccessRoute: AuthSuccessRoute,
  SsoCallbackProviderRoute: SsoCallbackProviderRoute,
  LangCompanyIdIndexRoute: LangCompanyIdIndexRoute,
  LangCompanyIdContactIdContactRoute: LangCompanyIdContactIdContactRoute,
  LangCompanyIdContactIdPreferenceCenterRoute:
    LangCompanyIdContactIdPreferenceCenterRoute,
  LangCompanyIdContactIdProfileRoute: LangCompanyIdContactIdProfileRoute,
  LangCompanyIdAdminEvaluationsRoute: LangCompanyIdAdminEvaluationsRoute,
  LangCompanyIdAdminHomeRoute: LangCompanyIdAdminHomeRoute,
  LangCompanyIdAdminUsersRoute: LangCompanyIdAdminUsersRoute,
  LangCompanyIdPublicContactRoute: LangCompanyIdPublicContactRoute,
  LangCompanyIdPublicSalesCallSessionRoute:
    LangCompanyIdPublicSalesCallSessionRoute,
  LangCompanyIdContactIdIndexRoute: LangCompanyIdContactIdIndexRoute,
  LangCompanyIdPartnerExternalReferenceResultRoute:
    LangCompanyIdPartnerExternalReferenceResultRoute,
  LangCompanyIdPublicAuthLoginRoute: LangCompanyIdPublicAuthLoginRoute,
  LangCompanyIdPublicAuthRegisterRoute: LangCompanyIdPublicAuthRegisterRoute,
  LangCompanyIdPublicAuthWaitlistRoute: LangCompanyIdPublicAuthWaitlistRoute,
  LangCompanyIdPublicValiantValiantDeviceIdRoute:
    LangCompanyIdPublicValiantValiantDeviceIdRoute,
  LangCompanyIdPublicDemoIndexRoute: LangCompanyIdPublicDemoIndexRoute,
  LangCompanyIdContactIdCockpitPropertyIdActivitiesRoute:
    LangCompanyIdContactIdCockpitPropertyIdActivitiesRoute,
  LangCompanyIdContactIdCockpitPropertyIdCalendarRoute:
    LangCompanyIdContactIdCockpitPropertyIdCalendarRoute,
  LangCompanyIdContactIdCockpitPropertyIdDocumentsRoute:
    LangCompanyIdContactIdCockpitPropertyIdDocumentsRoute,
  LangCompanyIdContactIdCockpitPropertyIdHomeRoute:
    LangCompanyIdContactIdCockpitPropertyIdHomeRoute,
  LangCompanyIdContactIdCockpitPropertyIdInterestRoute:
    LangCompanyIdContactIdCockpitPropertyIdInterestRoute,
  LangCompanyIdContactIdCockpitPropertyIdOffersRoute:
    LangCompanyIdContactIdCockpitPropertyIdOffersRoute,
  LangCompanyIdContactIdCockpitPropertyIdStatisticsRoute:
    LangCompanyIdContactIdCockpitPropertyIdStatisticsRoute,
  LangCompanyIdContactIdDossierDossierIdEvaluationRoute:
    LangCompanyIdContactIdDossierDossierIdEvaluationRoute,
  LangCompanyIdContactIdDossierDossierIdHomeRoute:
    LangCompanyIdContactIdDossierDossierIdHomeRoute,
  LangCompanyIdContactIdDossierDossierIdMarketRoute:
    LangCompanyIdContactIdDossierDossierIdMarketRoute,
  LangCompanyIdContactIdDossierDossierIdRegionRoute:
    LangCompanyIdContactIdDossierDossierIdRegionRoute,
  LangCompanyIdPublicDemoCockpitActivitiesRoute:
    LangCompanyIdPublicDemoCockpitActivitiesRoute,
  LangCompanyIdPublicDemoCockpitCalendarRoute:
    LangCompanyIdPublicDemoCockpitCalendarRoute,
  LangCompanyIdPublicDemoCockpitDocumentsRoute:
    LangCompanyIdPublicDemoCockpitDocumentsRoute,
  LangCompanyIdPublicDemoCockpitHomeRoute:
    LangCompanyIdPublicDemoCockpitHomeRoute,
  LangCompanyIdPublicDemoCockpitInterestRoute:
    LangCompanyIdPublicDemoCockpitInterestRoute,
  LangCompanyIdPublicDemoCockpitOffersRoute:
    LangCompanyIdPublicDemoCockpitOffersRoute,
  LangCompanyIdPublicDemoCockpitStatisticsRoute:
    LangCompanyIdPublicDemoCockpitStatisticsRoute,
  LangCompanyIdPublicDemoDossierEvaluationRoute:
    LangCompanyIdPublicDemoDossierEvaluationRoute,
  LangCompanyIdPublicDemoDossierHomeRoute:
    LangCompanyIdPublicDemoDossierHomeRoute,
  LangCompanyIdPublicDemoDossierMarketRoute:
    LangCompanyIdPublicDemoDossierMarketRoute,
  LangCompanyIdPublicDemoDossierRegionRoute:
    LangCompanyIdPublicDemoDossierRegionRoute,
  LangCompanyIdPublicEvaluationResultSessionIdRoute:
    LangCompanyIdPublicEvaluationResultSessionIdRoute,
  LangCompanyIdContactIdDossierDossierIdPropertyEditRoute:
    LangCompanyIdContactIdDossierDossierIdPropertyEditRoute,
  LangCompanyIdPublicExposeContactIdPropertyIdBookRoute:
    LangCompanyIdPublicExposeContactIdPropertyIdBookRoute,
  LangCompanyIdPublicExposeContactIdPropertyIdViewRoute:
    LangCompanyIdPublicExposeContactIdPropertyIdViewRoute,
  LangCompanyIdContactIdDossierDossierIdPropertyConditionEditRoute:
    LangCompanyIdContactIdDossierDossierIdPropertyConditionEditRoute,
  LangCompanyIdContactIdDossierDossierIdPropertyQualitiesEditRoute:
    LangCompanyIdContactIdDossierDossierIdPropertyQualitiesEditRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/valiant",
        "/auth/failure",
        "/auth/oauth",
        "/auth/success",
        "/sso/callback/$provider",
        "/$lang/$companyId/",
        "/$lang/$companyId/$contactId/contact",
        "/$lang/$companyId/$contactId/preference-center",
        "/$lang/$companyId/$contactId/profile",
        "/$lang/$companyId/admin/evaluations",
        "/$lang/$companyId/admin/home",
        "/$lang/$companyId/admin/users",
        "/$lang/$companyId/public/contact",
        "/$lang/$companyId/public/sales-call-session",
        "/$lang/$companyId/$contactId/",
        "/$lang/$companyId/partner/$externalReference/result",
        "/$lang/$companyId/public/auth/login",
        "/$lang/$companyId/public/auth/register",
        "/$lang/$companyId/public/auth/waitlist",
        "/$lang/$companyId/public/valiant/$valiantDeviceId",
        "/$lang/$companyId/public/demo/",
        "/$lang/$companyId/$contactId/cockpit/$propertyId/activities",
        "/$lang/$companyId/$contactId/cockpit/$propertyId/calendar",
        "/$lang/$companyId/$contactId/cockpit/$propertyId/documents",
        "/$lang/$companyId/$contactId/cockpit/$propertyId/home",
        "/$lang/$companyId/$contactId/cockpit/$propertyId/interest",
        "/$lang/$companyId/$contactId/cockpit/$propertyId/offers",
        "/$lang/$companyId/$contactId/cockpit/$propertyId/statistics",
        "/$lang/$companyId/$contactId/dossier/$dossierId/evaluation",
        "/$lang/$companyId/$contactId/dossier/$dossierId/home",
        "/$lang/$companyId/$contactId/dossier/$dossierId/market",
        "/$lang/$companyId/$contactId/dossier/$dossierId/region",
        "/$lang/$companyId/public/demo/cockpit/activities",
        "/$lang/$companyId/public/demo/cockpit/calendar",
        "/$lang/$companyId/public/demo/cockpit/documents",
        "/$lang/$companyId/public/demo/cockpit/home",
        "/$lang/$companyId/public/demo/cockpit/interest",
        "/$lang/$companyId/public/demo/cockpit/offers",
        "/$lang/$companyId/public/demo/cockpit/statistics",
        "/$lang/$companyId/public/demo/dossier/evaluation",
        "/$lang/$companyId/public/demo/dossier/home",
        "/$lang/$companyId/public/demo/dossier/market",
        "/$lang/$companyId/public/demo/dossier/region",
        "/$lang/$companyId/public/evaluation/result/$sessionId",
        "/$lang/$companyId/$contactId/dossier/$dossierId/property/edit",
        "/$lang/$companyId/public/expose/$contactId/$propertyId/book",
        "/$lang/$companyId/public/expose/$contactId/$propertyId/view",
        "/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit",
        "/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/valiant": {
      "filePath": "valiant.tsx"
    },
    "/auth/failure": {
      "filePath": "auth/failure.tsx"
    },
    "/auth/oauth": {
      "filePath": "auth/oauth.tsx"
    },
    "/auth/success": {
      "filePath": "auth/success.tsx"
    },
    "/sso/callback/$provider": {
      "filePath": "sso.callback.$provider.tsx"
    },
    "/$lang/$companyId/": {
      "filePath": "$lang.$companyId/index.tsx"
    },
    "/$lang/$companyId/$contactId/contact": {
      "filePath": "$lang.$companyId/$contactId/contact.tsx"
    },
    "/$lang/$companyId/$contactId/preference-center": {
      "filePath": "$lang.$companyId/$contactId/preference-center.tsx"
    },
    "/$lang/$companyId/$contactId/profile": {
      "filePath": "$lang.$companyId/$contactId/profile.tsx"
    },
    "/$lang/$companyId/admin/evaluations": {
      "filePath": "$lang.$companyId/admin/evaluations.tsx"
    },
    "/$lang/$companyId/admin/home": {
      "filePath": "$lang.$companyId/admin/home.tsx"
    },
    "/$lang/$companyId/admin/users": {
      "filePath": "$lang.$companyId/admin/users.tsx"
    },
    "/$lang/$companyId/public/contact": {
      "filePath": "$lang.$companyId/public/contact.tsx"
    },
    "/$lang/$companyId/public/sales-call-session": {
      "filePath": "$lang.$companyId/public/sales-call-session.tsx"
    },
    "/$lang/$companyId/$contactId/": {
      "filePath": "$lang.$companyId/$contactId/index.tsx"
    },
    "/$lang/$companyId/partner/$externalReference/result": {
      "filePath": "$lang.$companyId/partner.$externalReference/result.tsx"
    },
    "/$lang/$companyId/public/auth/login": {
      "filePath": "$lang.$companyId/public/auth/login.tsx"
    },
    "/$lang/$companyId/public/auth/register": {
      "filePath": "$lang.$companyId/public/auth/register.tsx"
    },
    "/$lang/$companyId/public/auth/waitlist": {
      "filePath": "$lang.$companyId/public/auth/waitlist.tsx"
    },
    "/$lang/$companyId/public/valiant/$valiantDeviceId": {
      "filePath": "$lang.$companyId/public/valiant.$valiantDeviceId.tsx"
    },
    "/$lang/$companyId/public/demo/": {
      "filePath": "$lang.$companyId/public/demo/index.tsx"
    },
    "/$lang/$companyId/$contactId/cockpit/$propertyId/activities": {
      "filePath": "$lang.$companyId/$contactId/cockpit.$propertyId/activities.tsx"
    },
    "/$lang/$companyId/$contactId/cockpit/$propertyId/calendar": {
      "filePath": "$lang.$companyId/$contactId/cockpit.$propertyId/calendar.tsx"
    },
    "/$lang/$companyId/$contactId/cockpit/$propertyId/documents": {
      "filePath": "$lang.$companyId/$contactId/cockpit.$propertyId/documents.tsx"
    },
    "/$lang/$companyId/$contactId/cockpit/$propertyId/home": {
      "filePath": "$lang.$companyId/$contactId/cockpit.$propertyId/home.tsx"
    },
    "/$lang/$companyId/$contactId/cockpit/$propertyId/interest": {
      "filePath": "$lang.$companyId/$contactId/cockpit.$propertyId/interest.tsx"
    },
    "/$lang/$companyId/$contactId/cockpit/$propertyId/offers": {
      "filePath": "$lang.$companyId/$contactId/cockpit.$propertyId/offers.tsx"
    },
    "/$lang/$companyId/$contactId/cockpit/$propertyId/statistics": {
      "filePath": "$lang.$companyId/$contactId/cockpit.$propertyId/statistics.tsx"
    },
    "/$lang/$companyId/$contactId/dossier/$dossierId/evaluation": {
      "filePath": "$lang.$companyId/$contactId/dossier.$dossierId/evaluation.tsx"
    },
    "/$lang/$companyId/$contactId/dossier/$dossierId/home": {
      "filePath": "$lang.$companyId/$contactId/dossier.$dossierId/home.tsx"
    },
    "/$lang/$companyId/$contactId/dossier/$dossierId/market": {
      "filePath": "$lang.$companyId/$contactId/dossier.$dossierId/market.tsx"
    },
    "/$lang/$companyId/$contactId/dossier/$dossierId/region": {
      "filePath": "$lang.$companyId/$contactId/dossier.$dossierId/region.tsx"
    },
    "/$lang/$companyId/public/demo/cockpit/activities": {
      "filePath": "$lang.$companyId/public/demo/cockpit/activities.tsx"
    },
    "/$lang/$companyId/public/demo/cockpit/calendar": {
      "filePath": "$lang.$companyId/public/demo/cockpit/calendar.tsx"
    },
    "/$lang/$companyId/public/demo/cockpit/documents": {
      "filePath": "$lang.$companyId/public/demo/cockpit/documents.tsx"
    },
    "/$lang/$companyId/public/demo/cockpit/home": {
      "filePath": "$lang.$companyId/public/demo/cockpit/home.tsx"
    },
    "/$lang/$companyId/public/demo/cockpit/interest": {
      "filePath": "$lang.$companyId/public/demo/cockpit/interest.tsx"
    },
    "/$lang/$companyId/public/demo/cockpit/offers": {
      "filePath": "$lang.$companyId/public/demo/cockpit/offers.tsx"
    },
    "/$lang/$companyId/public/demo/cockpit/statistics": {
      "filePath": "$lang.$companyId/public/demo/cockpit/statistics.tsx"
    },
    "/$lang/$companyId/public/demo/dossier/evaluation": {
      "filePath": "$lang.$companyId/public/demo/dossier/evaluation.tsx"
    },
    "/$lang/$companyId/public/demo/dossier/home": {
      "filePath": "$lang.$companyId/public/demo/dossier/home.tsx"
    },
    "/$lang/$companyId/public/demo/dossier/market": {
      "filePath": "$lang.$companyId/public/demo/dossier/market.tsx"
    },
    "/$lang/$companyId/public/demo/dossier/region": {
      "filePath": "$lang.$companyId/public/demo/dossier/region.tsx"
    },
    "/$lang/$companyId/public/evaluation/result/$sessionId": {
      "filePath": "$lang.$companyId/public/evaluation.result.$sessionId.tsx"
    },
    "/$lang/$companyId/$contactId/dossier/$dossierId/property/edit": {
      "filePath": "$lang.$companyId/$contactId/dossier.$dossierId/property.edit.tsx"
    },
    "/$lang/$companyId/public/expose/$contactId/$propertyId/book": {
      "filePath": "$lang.$companyId/public/expose/$contactId.$propertyId.book.tsx"
    },
    "/$lang/$companyId/public/expose/$contactId/$propertyId/view": {
      "filePath": "$lang.$companyId/public/expose/$contactId.$propertyId.view.tsx"
    },
    "/$lang/$companyId/$contactId/dossier/$dossierId/property/condition/edit": {
      "filePath": "$lang.$companyId/$contactId/dossier.$dossierId/property.condition.edit.tsx"
    },
    "/$lang/$companyId/$contactId/dossier/$dossierId/property/qualities/edit": {
      "filePath": "$lang.$companyId/$contactId/dossier.$dossierId/property.qualities.edit.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
